import { all } from "redux-saga/effects";

import getMenuSaga from "./getMenu";
import getDetail from "./getDetail";
import getListInternalDocs from "./getListInternalDocs";
import getListDocFormWork from "./getDocForm";

export default function* internalDocumentSaga() {
  yield all([
    getMenuSaga(),
    getDetail(),
    getListInternalDocs(),
    getListDocFormWork(),
  ]);
}
